// extracted by mini-css-extract-plugin
export default {"container":"FormButton_container__ASlWB","defaultBtn":"FormButton_defaultBtn__6gC-g","redBtn":"FormButton_redBtn__4m8eS","whiteBtn":"FormButton_whiteBtn__sw-WP"};